import { render, staticRenderFns } from "./MyHistorics.html?vue&type=template&id=4b3859ce&external"
import script from "./MyHistorics.vue?vue&type=script&lang=js"
export * from "./MyHistorics.vue?vue&type=script&lang=js"
import style0 from "./MyHistorics.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports